import ServiceExec from '@/common/utils/ServiceExec';
import BoardApi from '@/common/service/apis/BoardApi';

class BoardSvc extends ServiceExec {
  getNoticeList(params = {}) {
    return this.get(BoardApi.getNoticeList, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('getNoticeList error : ', error);
      });
  }

  getAlarmList(params = {}) {
    return this.get(BoardApi.getAlarmList, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('getAlarmList error : ', error);
      });
  }

  getFaqList(params = {}) {
    return this.get(BoardApi.getFaqList, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('getFaqList error : ', error);
      });
  }

  getBoardDetail(boardNo) {
    return this.patch(BoardApi.getBoardDetail(boardNo))
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('getBoardDetail error :', error);
      });
  }

  getAlarmDetail(alarmNo) {
    return this.patch(BoardApi.getAlarmDetail(alarmNo))
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('getAlarmDetail error :', error);
      });
  }
}

export default new BoardSvc();
